import React from 'react'
import { ReactComponent as GoogleIcon } from '../../images/icons/google_icon.svg'
import { ReactComponent as AmazonIcon } from '../../images/icons/audience_amazon.svg'
import { ReactComponent as TTDIcon } from '../../images/icons/audience_tradedesk.svg'
import { ReactComponent as FacebookLogo } from '../../images/facebook_ads_logo.svg'
import { ReactComponent as CSVIcon } from '../../images/icons/csv_icon.svg'
import { ReactComponent as FTPIcon } from '../../images/icons/ftp.svg'
import { ReactComponent as GoogleSheetsIcon } from '../../images/icons/google_sheets_icon.svg'
import { getImageURL } from './getImageURL'
import { uniq } from 'lodash'

const vendorIconMappings = {
  FTP_Upload: FTPIcon,
  'Manual Upload': CSVIcon,
  Google: GoogleIcon,
  GoogleLeads: GoogleIcon,
  'Google Leads': GoogleIcon,
  'Google Ads': GoogleIcon,
  Bing: () => <img src={getImageURL('images/bing_ads_logo.png')} />,
  'Bing Ads': () => <img src={getImageURL('images/bing_ads_logo.png')} />,
  Facebook: () => <img src={getImageURL('images/facebook_ads_logo.svg')} />,
  FacebookLeads: FacebookLogo,
  'Facebook Ads': FacebookLogo,
  Mailchimp: () => <img src={getImageURL('images/mailchimp_logo.png')} />,
  GoogleSpreadSheets: GoogleSheetsIcon,
  Elead: () => <img src={getImageURL('images/vendors/Elead_Logo_RGB.png')} />,
  TradeDesk: () => <img src={getImageURL('images/vendors/ttd_small.png')} />,
  'Trade Desk': () => <img src={getImageURL('images/vendors/ttd_small.png')} />,
  DealerVault: () => <img src={getImageURL('images/vendors/dealer_vault_icon.svg')} />,
  VinSolutions: () => <img src={getImageURL('images/vinsolutions_logo.png')} />,
  Advanse: () => <img src={getImageURL('images/vendors/advanse_logo.png')} />,
  DealerSocket: () => <img src={getImageURL('images/vendors/dealer_socket_logo.png')} />,
  CDK: () => <img src={getImageURL('images/vendors/cdk_logo.svg')} />,
  Tekion: () => <img src={getImageURL('images/vendors/tekion_logo.png')} />,
  DriveCentric: () => <img src={getImageURL('images/vendors/drive_centric_icon.png')} />,
  Procede: () => <img src={getImageURL('images/vendors/procede_logo_large.png')} />,
  Amazon: () => <img src={getImageURL('images/vendors/amazon_ads_logo.png')} />,
  DemandLocal: () => <img src={getImageURL('images/dl_logo_favicon.svg')} />,
}

export const mapVendorsToIcons = (vendors: string[], key = ''): JSX.Element[] => {
  return uniq(
    vendors.filter((vendor) => Object.keys(vendorIconMappings).includes(vendor)),
  ).map((vendor_name: string, i) => {
    const IconComponent =
      vendorIconMappings?.[vendor_name as keyof typeof vendorIconMappings] || CSVIcon
    return <IconComponent key={`${key}-${i}`} />
  })
}

export const productCodeToVendorIcon = (product_code: string): JSX.Element => {
  let IconComponent = vendorIconMappings['DemandLocal']
  if (product_code === 'DYD' || product_code === 'OTT' || product_code === 'CTV') {
    return <TTDIcon className="w-[25px] h-[25px]" />
  } else if (
    product_code === 'DYN' ||
    product_code === 'FDL' ||
    product_code === 'DSL' ||
    product_code === 'FDS' ||
    product_code === 'FML'
  ) {
    IconComponent = vendorIconMappings['Facebook']
  } else if (
    product_code === 'VLA' ||
    product_code === 'TRV' ||
    product_code === 'PMX' ||
    product_code === 'DSC' ||
    product_code === 'MPX' ||
    product_code === 'MVA'
  ) {
    return <GoogleIcon className="w-[25px] h-[25px]" />
  } else if (product_code === 'BVA') {
    IconComponent = vendorIconMappings['Bing Ads']
  } else if (product_code === 'INV' || product_code === 'SEM' || product_code === 'MSE') {
    return (
      <>
        <GoogleIcon className="w-[25px] h-[25px]" />
        <img
          className="w-[25px] h-[25px]"
          src={getImageURL('images/bing_ads_logo.png')}
        />
      </>
    )
  } else if (product_code === 'AZD' || product_code === 'AZV' || product_code === 'ADA') {
    return <AmazonIcon className="w-[25px] h-[25px]" />
  } else {
    IconComponent = vendorIconMappings['DemandLocal']
  }
  return (
    <div className="w-[25px] h-[25px]">
      <IconComponent />
    </div>
  )
}
